export interface TemplateValidationError {
    versionId: string
    message: string
    attributePath?: string
}

export const GENERIC_ERROR_KEY = 'GENERIC_ERROR_KEY'

/**
 * Carries the errors of a 422 TemplateValidationException so callers can attribute them to the
 * content that produced them instead of only showing the response message.
 */
export class TemplateValidationErrorsThrowable extends Error {
    errors: TemplateValidationError[]

    constructor(errors: TemplateValidationError[]) {
        super('The content did not pass validation.')
        this.errors = errors
    }
}

export interface ValidationErrorEntity {
    id: string
    validationErrors: Record<string, string[]> // a map of attributes path and list of error messages
}
